import {observable, action} from 'mobx';
import _ from 'lodash';

class McqSessionStore {
  @observable session = {};
  @observable lastSession = {};
  @observable question = {};
  @observable answerIndex = null;

  @action
  setSession = (session) => {
    this.session = session;
  };

  @action
  setLastSession = (lastSession) => {
    this.lastSession = lastSession;
  };

  @action
  setQuestion = (question) => {
    this.question = question;
  };

  @action
  clearSession = () => {
    this.session = {};
  };

  @action
  clearLastSession = () => {
    this.lastSession = {};
  };

  @action
  clearQuestion = () => {
    this.question = {};
  };

  @action
  changeAnswerIndex = (index) => {
    this.answerIndex = index;
  };
};

export default new McqSessionStore();



// WEBPACK FOOTER //
// ./src/stores/McqSessionStore.js